import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import DataParser from "../../../utlits/Dataparser";
import Sidebar from "../../Layouts/Sidebar";
import "./AdminSettings.css";

const AdminSettings = () => {
  const [userPermissions, setuserPermissions] = useState([]);

  useEffect(() => {
    const upermission = DataParser.CompanyUserPermissions();
    setuserPermissions(upermission);
  }, []);

  return (
    <>
      {/* <Sidebar /> */}
      <div className="main-content">
        <div className="page-content Pagebody" style={{ backgroundColor: "#fff", minHeight: "100vh" }}>

          <div className="container-fluid">
            <div className="row">
              <div className="col-12 px-0">
                <div className="admin-settings-grid">
                  {userPermissions.indexOf("leadsource-list") !== -1 ? (
                    <Link to={`/${DataParser.CompanyIdentifierRole()}/secondary-lead-source`}>
                      <div className="card admin-settings-card">
                        <div className="card-body setting_tabs">
                          <i className="uil-presentation-lines-alt setting_tabs_icon" />
                          <h4 className="setting_tabs_text">Secondary Lead Source</h4>
                        </div>
                      </div>
                    </Link>
                  ) : null}

                  {userPermissions.indexOf("role-list") !== -1 ? (
                    <Link to={`/${DataParser.CompanyIdentifierRole()}/roles`}>
                      <div className="card admin-settings-card">
                        <div className="card-body setting_tabs">
                          <i
                            className="uil-user-exclamation setting_tabs_icon"
                          />
                          <h4 className="setting_tabs_text">
                            User Roles/Permssions
                          </h4>
                        </div>
                      </div>
                    </Link>
                  ) : null}

                  {userPermissions.indexOf("departments-list") !== -1 ? (
                    <Link to={`/${DataParser.CompanyIdentifierRole()}/departments`}>
                      <div className="card admin-settings-card">
                        <div className="card-body setting_tabs">
                          <i className="uil-building setting_tabs_icon" />
                          <h4 className="setting_tabs_text">Company Departments</h4>
                        </div>
                      </div>
                    </Link>
                  ) : null}

                  {userPermissions.indexOf("designation-list") !== -1 ? (
                    <Link to={`/${DataParser.CompanyIdentifierRole()}/designations`}>
                      <div className="card admin-settings-card">
                        <div className="card-body setting_tabs">
                          <i className="uil-briefcase setting_tabs_icon" />
                          <h4 className="setting_tabs_text">Company Designations</h4>
                        </div>
                      </div>
                    </Link>
                  ) : null}

                  {userPermissions.indexOf("jobstatus-list") !== -1 ? (
                    <Link to={`/${DataParser.CompanyIdentifierRole()}/employeejob`}>
                      <div className="card admin-settings-card">
                        <div className="card-body setting_tabs">
                          <i
                            className="uil-bag setting_tabs_icon"
                          />
                          <h4 className="setting_tabs_text">
                            Employement Status
                          </h4>
                        </div>
                      </div>
                    </Link>
                  ) : null}

                  {userPermissions.indexOf("user-list") !== -1 ? (
                    <Link to={`/${DataParser.CompanyIdentifierRole()}/users`}>
                      <div className="card admin-settings-card">
                        <div className="card-body setting_tabs">
                          <i
                            className="uil-users-alt setting_tabs_icon"
                          />
                          <h4 className="setting_tabs_text">
                            All Employees
                          </h4>
                        </div>
                      </div>
                    </Link>
                  ) : null}

                  {/* {userPermissions.indexOf("jobstatus-list") !== -1 ? (
                    <div className="col-md-6 col-xl-3">
                      <Link to={`/${DataParser.CompanyIdentifierRole()}/employeejob`}>
                        <div className="card">
                          <div className="card-body setting_tabs">
                            <i
                              style={{ color: "#000" }}
                              className="uil-bag setting_tabs_icon"
                            />

                            <h4 className="mb-1 mt-1 setting_tabs_text">
                              {" "}
                              Employee job status
                            </h4>
                          </div>
                        </div>
                      </Link>
                    </div>
                  ) : null} */}

                  {userPermissions.indexOf("leaveperiod-list") !== -1 ? (
                    <Link
                      to={`/${DataParser.CompanyIdentifierRole()}/leaveperiod`}
                    >
                      <div className="card admin-settings-card">
                        <div className="card-body setting_tabs">
                          <i
                            className="uil-bag setting_tabs_icon"
                          />
                          <h4 className="setting_tabs_text">
                            Annual Leave Period
                          </h4>
                        </div>
                      </div>
                    </Link>
                  ) : null}

                  {userPermissions.indexOf("leavetype-list") !== -1 ? (
                    <Link
                      to={`/${DataParser.CompanyIdentifierRole()}/leave_type`}
                    >
                      <div className="card admin-settings-card">
                        <div className="card-body setting_tabs">
                          <i
                            className="uil-notebooks setting_tabs_icon"
                          />
                          <h4 className="setting_tabs_text">
                            Leave Type
                          </h4>
                        </div>
                      </div>
                    </Link>
                  ) : null}




                  {userPermissions.indexOf("holiday-list") !== -1 ? (
                    <Link to={`/${DataParser.CompanyIdentifierRole()}/holidays`}>
                      <div className="card admin-settings-card">
                        <div className="card-body setting_tabs">
                          <i
                            className="uil-megaphone setting_tabs_icon"
                          />
                          <h4 className="setting_tabs_text">Company Holidays</h4>
                        </div>
                      </div>
                    </Link>
                  ) : null}

                  {userPermissions.indexOf("priority-list") !== -1 ? (
                    <Link to={`/${DataParser.CompanyIdentifierRole()}/priority`}>
                      <div className="card admin-settings-card">
                        <div className="card-body setting_tabs">
                          <i
                            className="uil-file-check setting_tabs_icon"
                          />
                          <h4 className="setting_tabs_text">Tasks Piority</h4>
                        </div>
                      </div>
                    </Link>
                  ) : null}

                  {userPermissions.indexOf("communicationsource-list") !== -1 ? (
                    <Link
                      to={`/${DataParser.CompanyIdentifierRole()}/lead-source`}
                    >
                      <div className="card admin-settings-card">
                        <div className="card-body setting_tabs">
                          <i
                            className="uil-user-arrows setting_tabs_icon"
                          />
                          <h4 className="setting_tabs_text">
                            Lead Source
                          </h4>
                        </div>
                      </div>
                    </Link>
                  ) : null}

                  {userPermissions.indexOf("relatedto-list") !== -1 ? (
                    <Link
                      to={`/${DataParser.CompanyIdentifierRole()}/lead-type`}
                    >
                      <div className="card admin-settings-card">
                        <div className="card-body setting_tabs">
                          <i
                            className="uil-link setting_tabs_icon"
                          />
                          <h4 className="setting_tabs_text">
                          Lead Interest
                          </h4>
                        </div>
                      </div>
                    </Link>
                  ) : null}

                  {userPermissions.indexOf("leadstatus-list") !== -1 ? (
                    <Link to={`/${DataParser.CompanyIdentifierRole()}/lead_status`}>
                      <div className="card admin-settings-card">
                        <div className="card-body setting_tabs">
                          <i className="uil-list-ul setting_tabs_icon" />
                          <h4 className="setting_tabs_text">Lead Status</h4>
                        </div>
                      </div>
                    </Link>
                  ) : null}

                  {userPermissions.indexOf("prospectamount-list") !== -1 ? (
                    <Link to={`/${DataParser.CompanyIdentifierRole()}/prospect_amount`}>
                      <div className="card admin-settings-card">
                        <div className="card-body setting_tabs">
                          <i className="uil-money-bill setting_tabs_icon" />
                          <h4 className="setting_tabs_text">Prospect Amount</h4>
                        </div>
                      </div>
                    </Link>
                  ) : null}

                  {userPermissions.indexOf("performanceperiod-list") !== -1 ? (
                    <Link
                      to={`/${DataParser.CompanyIdentifierRole()}/performanceperiod`}
                    >
                      <div className="card admin-settings-card">
                        <div className="card-body setting_tabs">
                          <i
                            className="uil-calendar-alt  setting_tabs_icon"
                          />
                          <h4 className="setting_tabs_text">
                            Performance Evaluation Period
                          </h4>
                        </div>
                      </div>
                    </Link>
                  ) : null}

                  {userPermissions.indexOf("weightages-list") !== -1 ? (
                    <Link
                      to={`/${DataParser.CompanyIdentifierRole()}/performanceweightage`}
                    >
                      <div className="card admin-settings-card">
                        <div className="card-body setting_tabs">
                          <i
                            className="uil-analytics  setting_tabs_icon"
                          />
                          <h4 className="setting_tabs_text">
                            Performance Weightage
                          </h4>
                        </div>
                      </div>
                    </Link>
                  ) : null}

                  {userPermissions.indexOf("pastdaysettings-list") !== -1 ? (
                    <Link to={`/${DataParser.CompanyIdentifierRole()}/past_days_settings`}>
                      <div className="card admin-settings-card">
                        <div className="card-body setting_tabs">
                          <i className="uil-clock-three setting_tabs_icon" />
                          <h4 className="setting_tabs_text">Past Days Settings</h4>
                        </div>
                      </div>
                    </Link>
                  ) : null}

                  {userPermissions.indexOf("ipaddress-list") !== -1 ? (
                    <Link to={`/${DataParser.CompanyIdentifierRole()}/ipaddress`}>
                      <div className="card admin-settings-card">
                        <div className="card-body setting_tabs">
                          <i className="uil-server setting_tabs_icon" />
                          <h4 className="setting_tabs_text">IP Address</h4>
                        </div>
                      </div>
                    </Link>
                  ) : null}

                  {userPermissions.indexOf("machine-integration-list") !== -1 ? (
                    <Link to={`/${DataParser.CompanyIdentifierRole()}/machine-integration`}>
                      <div className="card admin-settings-card">
                        <div className="card-body setting_tabs">
                          <i className="uil-processor setting_tabs_icon" />
                          <h4 className="setting_tabs_text">Machine Integration</h4>
                        </div>
                      </div>
                    </Link>
                  ) : null}



                  {userPermissions.indexOf("sessionout-list") !== -1 ? (
                    <Link to={`/${DataParser.CompanyIdentifierRole()}/session-management`}>
                      <div className="card admin-settings-card">
                        <div className="card-body setting_tabs">
                          <i className="uil-hourglass setting_tabs_icon" />
                          <h4 className="setting_tabs_text">Session Management</h4>
                        </div>
                      </div>
                    </Link>
                  ) : null}

                  {userPermissions.indexOf("force-checkout-time-list") !== -1 ? (
                    <Link to={`/${DataParser.CompanyIdentifierRole()}/force-checkout-time`}>
                      <div className="card admin-settings-card">
                        <div className="card-body setting_tabs">
                          <i className="uil-clock setting_tabs_icon" />
                          <h4 className="setting_tabs_text">Force Checkout Time</h4>
                        </div>
                      </div>
                    </Link>
                  ) : null}

                  {userPermissions.indexOf("companyshifts-list") !== -1 ? (
                    <Link to={`/${DataParser.CompanyIdentifierRole()}/company_shifts`}>
                      <div className="card admin-settings-card">
                        <div className="card-body setting_tabs">
                          <i className="uil-clock-eight setting_tabs_icon" />
                          <h4 className="setting_tabs_text">Company Shifts</h4>
                        </div>
                      </div>
                    </Link>
                  ) : null}

                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default AdminSettings;
